export function formatToLowerKebabCase(sourceString: string) {
  return sourceString.toLowerCase().split(' ').join('-');
}
